import { useMemo, useState } from "react";
import ProductCard from "../components/ProductCard";
import Categories from "../components/Categories";
import Footer from "../components/Footer";
import { products } from "../data/products";

const Shop = ({
  pageTitle = "Shop",
  onAddToCart,
  onOpenDetails,
  onToggleWishlist,
  cartItems,
  wishlistItems,
}) => {
  const [activeCategory, setActiveCategory] = useState("");

  const visibleProducts = useMemo(
    () =>
      activeCategory
        ? products.filter((product) => product.category === activeCategory)
        : products,
    [activeCategory]
  );

  return (
    <>
      <main className="page-shell">
        <section className="shop-hero">
          <div className="section-container">
            <p className="eyebrow">Veda Glow store</p>
            <h1>{pageTitle}</h1>
            <span>
              Explore premium Indian skincare by category, texture, and daily ritual.
            </span>
          </div>
        </section>

        <Categories activeCategory={activeCategory} onSelectCategory={setActiveCategory} />

        <section className="product-grid-section" id="products">
          <div className="section-container">
            <div className="section-heading split">
              <div>
                <p>Signature collection</p>
                <h2>{activeCategory ? `${activeCategory} Products` : "All Products"}</h2>
                <span>
                  High-performance Indian skincare with ritual-led ingredients, clean actives, and refined daily textures.
                </span>
              </div>
              {activeCategory ? (
                <button className="text-link" type="button" onClick={() => setActiveCategory("")}>View all products</button>
              ) : null}
            </div>

            <div className="product-grid">
              {visibleProducts.map((item) => (
                <ProductCard
                  key={item.id}
                  product={item}
                  onAddToCart={onAddToCart}
                  onOpenDetails={onOpenDetails}
                  onToggleWishlist={onToggleWishlist}
                  cartQuantity={cartItems[item.id] || 0}
                  isWishlisted={Boolean(wishlistItems[item.id])}
                />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Shop;
